import { config } from '../../utils/config'

export type ReportingStoreRep = {
  id: string
  name: string
  email?: string
}

export async function getReportingStoreReps(
  token: string | null | undefined,
): Promise<ReportingStoreRep[]> {
  const response = await fetch(
    `${config.publicRuntimeConfig.humpclubRoot}/reporting/v2/store-reps`,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    },
  )

  if (!response.ok) {
    throw new Error(`Store reps request failed (${response.status})`)
  }

  return response.json()
}
